import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Department } from '@pixacare/domain';
import { TuiDataList, TuiFilterByInputPipe, TuiInput, TuiSelectLike } from '@taiga-ui/core';
import { TuiChevron, TuiDataListWrapper, TuiInputChip, TuiMultiSelect } from '@taiga-ui/kit';

@UntilDestroy()
@Component({
  selector: 'pxc-collaborative-departments-picker',
  imports: [
    FormsModule,
    TranslocoModule,
    TuiChevron,
    TuiDataList,
    TuiDataListWrapper,
    TuiFilterByInputPipe,
    TuiInputChip,
    TuiMultiSelect,
    TuiInput,
    TuiSelectLike,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollaborativeDepartmentsPickerComponent),
      multi: true,
    },
  ],
  templateUrl: './collaborative-departments-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-2' },
})
export class CollaborativeDepartmentsPickerComponent implements ControlValueAccessor {
  @Input() departments: Department[] = [];

  value: Department[];

  private onChange: (value: number[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: number[]): void {
    this.value = this.departments.filter((department) => value?.includes(department.id)) || [];
  }

  registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectDepartments(departments: Department[]): void {
    this.value = departments;
    this.onChange(departments.map((department) => department.id));
    this.onTouched();
  }

  stringify(item: Department): string {
    return item?.name || '';
  }
}
